export const SMART_PROMO_CATEGORY_NAMES = {
  DOW: "Days Of Week",
  LOS: "Length Of Stay",
  LEAD_TIME: "Lead Time",
  alignment: "Alignment",
  BLACK_FRIDAY: "Black Friday",
};

export const resolveSmartPromoType = (promo, isMarket) => {
  if (isMarket) return "SMART";
  return promo?.promoType?.toUpperCase() || "CUSTOM";
};

export const buildSmartPromoSuccessMessage = (
  promoCategory,
  entityLabel,
  action
) => {
  const name = SMART_PROMO_CATEGORY_NAMES[promoCategory] || "Recommended";
  return `${name} ${entityLabel} has successfully ${action} and is now live.`;
};

export const getSaveType = ({
  isMarket,
  isEditMode,
  isDuplicateMode,
  isDraft,
} = {}) => {
  if (isMarket) return "saved";
  if (isDraft) return `${isDuplicateMode ? "duplicated" : "saved"} as draft`;
  if (isEditMode && !isDuplicateMode) return "edited";
  return isDuplicateMode ? "duplicated" : "saved";
};

export const getActionType = ({ isMarket, isEdit, isDuplicate } = {}) => {
  if (isMarket) return "created";
  if (isEdit) return "edited";
  if (isDuplicate) return "duplicated";
  return "created";
};

export const getFailedNames = (results) =>
  results
    .filter((r) => !r.success)
    .map((r) => r.name)
    .join(", ");

export const getErrorMessages = (results) =>
  results
    .filter((r) => !r.success)
    .map((r) => `${r.name}: ${r.error || r.message || "Unknown error"}`)
    .join("; ");
